import domtoimage from "dom-to-image";
import {socialWallRef} from "../config/firebaseConfig";
import {ItemTypes} from "../pages/SocialWallPage";
import {ItemStatuses} from "../constants";
import {getCurrentUser} from "../pages/root/helpers";
import {download} from "./index";
import {canvasToBase64, base64ToIm} from "./img/imageHelpers";

export const convertToFinalImage = (selectedFrame) => new Promise((resolve, reject) => {

    window.CANVAS.discardActiveObject();

    const S_WIDTH = 1620, S_HEIGHT = 1620;

    // #canvas is the video capture image with border image
    const canvasServer = document.getElementById("booth_canvas_final");
    const canvasServer_context = canvasServer.getContext("2d");
    canvasServer_context.clearRect(0, 0, S_WIDTH, S_HEIGHT);

    const canvasImage = document.getElementById("booth_canvas_image");
    canvasServer_context.drawImage(canvasImage,20,120, S_WIDTH, S_HEIGHT);

    base64ToIm(selectedFrame).then(frame_img => {
        canvasServer_context.drawImage(frame_img,0,0, S_WIDTH, S_HEIGHT + 10);
        const sticker = document.getElementById('sticker_canvas');

        const final_sticker_canvas = document.getElementById('booth_final_sticker_canvas');
        const final_sticker_canvas_context = final_sticker_canvas.getContext("2d");
        final_sticker_canvas_context.clearRect(0, 0, S_WIDTH, S_HEIGHT);

        final_sticker_canvas_context.drawImage(sticker, 0, 0, S_WIDTH - 60, S_HEIGHT - 60);

        // draw sticker canvas image over the video capture image
        canvasServer_context.drawImage(final_sticker_canvas, 0, 0, S_WIDTH, S_HEIGHT);
        const imageDataURL = canvasToBase64(canvasServer);
        resolve(imageDataURL)
    })
})

const restoreInitialStickerCanvas = (canvas, width, height) => {
    canvas.removeAttribute('className')
    canvas.removeAttribute('style')
    canvas.setAttribute('width', width)
    canvas.setAttribute('height', height)
}

//wrapper - sticker container, created by fabric.js
const unwrap = (wrapper, w, h) => {
    const stickerCanvas = wrapper.childNodes.item(0)
    restoreInitialStickerCanvas(stickerCanvas, w, h)
    wrapper.replaceWith(stickerCanvas);
}

export const unwrapAll = (w, h) => {
    const wrappers = document.getElementsByClassName('canvas-container')
    for (let wr of wrappers) {
        unwrap(wr, w, h)
    }
}

export const domToImage = url => new Promise((res, rej) => {
    const finalImageRef = document.getElementById('final-image-container');
    let frame_img = new Image();
    frame_img.src = url;
    frame_img.onload = function () {
        domtoimage.toPng(finalImageRef)
            .then(res).catch(rej);
    }
});


export const submitSocialItem = (data, type) => {

    const {CustID} = getCurrentUser()

    return socialWallRef.add({
        data,
        type: type,
        status: ItemStatuses.SUBMITTED,
        timestamp: Date.now(),//firebase.firestore.FieldValue.serverTimestamp(),
        userId: CustID,
    })
        .then(r => console.log('uploaded'))
        .catch(err => console.error(err))
}

export const downloadImage = imageURL => {
    let frame_img = new Image(1620, 1620);
    frame_img.src = imageURL;
    frame_img.onload = () => download(imageURL, 'SBA2020_Selfie.png')
};